module.exports = __webpack_public_path__ + "img/9.b1f15b40.png";